var map = {
	"./android.png": 261,
	"./divineprop.png": 262,
	"./ecomm.png": 263,
	"./feedbellie.png": 264,
	"./ios.png": 265,
	"./kdr.png": 266,
	"./kdr/1.png": 267,
	"./kdr/2.png": 268,
	"./kdr/3.png": 269,
	"./kdr/4.png": 270,
	"./kdr/5.png": 271,
	"./kdr/VanamaliLogo.png": 272,
	"./kdr/d1.png": 273,
	"./kdr/divinelogo.png": 274,
	"./kdr/ec.png": 275,
	"./kdr/ecom.png": 276,
	"./kdr/ecomlogo.png": 277,
	"./kdr/f1.png": 278,
	"./kdr/f10.png": 279,
	"./kdr/f2.png": 280,
	"./kdr/f4.png": 281,
	"./kdr/f8.png": 282,
	"./kdr/fb.png": 283,
	"./kdr/fb1.png": 284,
	"./kdr/fb2.png": 285,
	"./kdr/fb3.png": 286,
	"./kdr/fb4.png": 287,
	"./kdr/fb5.png": 288,
	"./kdr/kdr.png": 289,
	"./kdr/m1.png": 290,
	"./kdr/m2.png": 291,
	"./kdr/m3.png": 292,
	"./kdr/m5.png": 293,
	"./kdr/m6.png": 294,
	"./kdr/m7.png": 295,
	"./kdr/mananagaram.png": 296,
	"./kdr/n1.png": 297,
	"./kdr/n2.png": 298,
	"./kdr/n3.png": 299,
	"./kdr/n4.png": 300,
	"./kdr/n5.png": 301,
	"./kdr/nalgonda.png": 302,
	"./kdr/s1.png": 303,
	"./kdr/s2.png": 304,
	"./kdr/s3.png": 305,
	"./kdr/s4.png": 306,
	"./kdr/s5.png": 307,
	"./kdr/snfoods.png": 308,
	"./kdr/srpt.png": 309,
	"./kdr/startcareer.png": 310,
	"./kdr/v1.png": 311,
	"./kdr/w1.png": 312,
	"./kdr/w2.png": 313,
	"./kdr/w3.png": 314,
	"./kdr/w4.png": 315,
	"./kdr/w5.png": 316,
	"./kdr/wapp.png": 317,
	"./mana.png": 318,
	"./nalgonda.png": 319,
	"./nalgov.png": 320,
	"./quote.svg": 49,
	"./sc.png": 321,
	"./send.svg": 322,
	"./snfood.png": 323,
	"./testScreenShot.png": 324,
	"./vanamali.png": 325,
	"./web.png": 326,
	"./webecomm.png": 327,
	"./wordsapp.png": 328,
	"./wordsapp.webp": 439
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 346;